import { Button, styled } from "@mui/material"

export const SelectSectionButton = styled(Button)({
    width: "125px",
    height: "47px",
    fontWeight: 600,
    fontSize: "10px",
    padding: 1.5,
    border: '1px solid',
    fontStyle: 'normal',
    letterSpacing: '0.416552px'
    // borderColor: 'primamary'
})
